module.exports = __webpack_public_path__ + "IN.png?5066387816e2a3b09b73ad1e335e5573";